import { useEffect, useRef, useState } from "react";
import { chatService } from "../service";

export default function useChat(currentUserId) {
  const [users, setUsers] = useState([]);
  const [activeUser, setActiveUser] = useState(null);
  const [messages, setMessages] = useState([]);
  const [socket, setSocket] = useState(null);
  const [onlineUsers, setOnlineUsers] = useState([]);

  const messageInputRef = useRef(null);

  // Fetch all chat users on mount
  useEffect(() => {
    const fetchUsers = async () => {
      try {
        const { data } = await chatService.getUsers();
        setUsers(data);
      } catch (err) {
        console.error("Erreur lors du chargement des utilisateurs du chat:", err);
      }
    };
    fetchUsers();
  }, []);

  // Open WebSocket connection
  useEffect(() => {
    if (!currentUserId) return;

    const ws = chatService.connectSocket(currentUserId);
    ws.onopen = () => console.log(" WebSocket connecté");
    ws.onclose = () => console.log("WebSocket fermé");
    ws.onerror = (err) => console.error("Erreur WebSocket:", err);

    ws.onmessage = (event) => {
      try {
        const payload = JSON.parse(event.data);
        if (payload.type === "message") {
          setMessages((prev) => [...prev, payload]);
        } else if (payload.type === "online_users") {
          setOnlineUsers(payload.online);
        }
      } catch (e) {
        console.error("Erreur de message WebSocket:", e);
      }
    };

    setSocket(ws);
    return () => ws.close();
  }, [currentUserId]);

  // Fetch messages when active user changes
  useEffect(() => {
    const fetchMessages = async () => {
      if (!activeUser || !currentUserId) return;
      try {
        const { data } = await chatService.getMessages(currentUserId, activeUser.id);
        setMessages(data);
      } catch (err) {
        console.error("Erreur lors du chargement des messages:", err);
      }
    };
    fetchMessages();
  }, [activeUser, currentUserId]);

  // Send a message
  const sendMessage = (text) => {
    if (!socket || !activeUser || !text.trim()) return;
    const msg = {
      type: "message",
      sender_id: currentUserId,
      receiver_id: activeUser.id,
      content: text.trim(),
    };
    socket.send(JSON.stringify(msg));
    setMessages((prev) => [
      ...prev,
      { ...msg, timestamp: new Date().toISOString() },
    ]);
    messageInputRef.current.value = "";
  };

  return {
    users,
    activeUser,
    setActiveUser,
    messages,
    sendMessage,
    messageInputRef,
    onlineUsers,
  };
}
